export async function readSSE(res, {
  onStart, onChunk, onToolStart, onTool, onToolError,
  onSources, onDone, onError,
} = {}) {
  const reader  = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = '', full = '', meta = {};

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const lines = buf.split('\n');
    buf = lines.pop();
    for (const line of lines) {
      if (!line.startsWith('data:')) continue;
      const raw = line.slice(5).trim();
      if (!raw || raw === '[DONE]') continue;
      try {
        const p = JSON.parse(raw);
        const t = p.type;

        if (t === 'start') {
          onStart?.({ sessionId: p.session_id });
        } else if (t === 'chunk') {
          full += p.text;
          onChunk?.(p.text, full);
        } else if (!t && p.chunk) {
          // legacy fallback
          full += p.chunk;
          onChunk?.(p.chunk, full);
        } else if (t === 'tool_start') {
          onToolStart?.({ name: p.name, callId: p.call_id || '' });
        } else if (t === 'tool') {
          onTool?.({ name: p.name, result: p.result });
        } else if (t === 'tool_error') {
          onToolError?.({ name: p.name, error: p.error });
        } else if (!t && p.mcp_tool) {
          // legacy fallback
          onTool?.({ name: p.mcp_tool, result: p.result_preview });
        } else if (t === 'sources') {
          onSources?.(p.items || []);
          meta = { ...meta, sources: p.items || [] };
        } else if (t === 'error') {
          meta = {
            ...meta,
            error: p.message,
            code: p.code || 'assistant_unavailable',
            recoverable: p.recoverable !== false,
            retryAfter: p.retry_after || null,
            provider: p.provider || null,
            timestamp: p.timestamp,
            user_timestamp: p.user_timestamp,
          };
          onError?.({ message: p.message, code: meta.code, recoverable: meta.recoverable, retryAfter: meta.retryAfter });
          onDone?.({ reply: full, ...meta });
          return;
        } else if (!t && p.error) {
          // legacy fallback
          meta = { ...meta, error: p.error, code: p.code || 'assistant_unavailable', recoverable: true };
          onError?.({ message: p.error, code: meta.code, recoverable: true });
        } else if (t === 'done') {
          meta = {
            ...meta,
            timestamp: p.timestamp,
            user_timestamp: p.user_timestamp,
            tokens: p.token_usage,
            structured: p.structured || null,
          };
        } else if (!t && p.done) {
          // legacy fallback
          meta = { ...meta, tokens: p.token_usage, timestamp: p.timestamp, user_timestamp: p.user_timestamp };
        }
      } catch {}
    }
  }
  onDone?.({ reply: full, ...meta });
}
